define.alias("shared/components/shared/ui/button", "calendar/components/shared/ui/button");